import Vue from 'vue'
import Router from 'vue-router'
import IndexNew from '@/components/IndexNew/IndexNew.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'IndexNew',
      component: IndexNew,
      meta: {
        title: 'CopyCheck官网入口-论文查重-论文检测-免费论文查重检测系统',
        sideBarKeepAlive: true
      }
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: () => import('@/components/AboutusNew/IndexNew.vue'),
      meta: {
        title: '关于我们',
        sideBarKeepAlive: true
      }
    },
    {
      path: '/verify',
      name: 'verify',
      component: () => import('@/components/VerifyNew/IndexNew.vue'),
      meta: {
        title: '验证真伪',
        sideBarKeepAlive: true
      }
    },
    {
      path: '/profile',
      name: 'my',
      component: () => import('@/components/Qiye/My/Index.vue'),
      meta: {
        title: '个人中心'
      }
    },
    {
      path: '/jigou',
      name: 'jigou',
      component: () => import('@/components/Enterprise/Index.vue'),
      meta: {
        title: '机构版'
      }
    },
    {
      path: '/uploadpaper',
      name: 'uploadpaper',
      component: () => import('@/components/Qiye/Testreport/UploadPaper.vue'),
      meta: {
        title: '检测报告'
      }
    },
    {
      path: '/report',
      name: 'testreport',
      component: () => import('@/components/Qiye/Testreport/Index.vue'),
      meta: {
        title: '报告列表'
      }
    },
    {
      path: '/trustpapers',
      name: 'TrustPapers',
      component: () => import('@/components/Qiye/Testreport/TrustPapers.vue'),
      meta: {
        title: '自建库'
      }
    },
    {
      path: '/userProfile',
      name: 'userProfile',
      component: () => import('@/components/User/Profile/Index.vue'),
      meta: {
        title: '个人中心'
      }
    },
    {
      path: '/userReport',
      name: 'userReport',
      component: () => import('@/components/User/Report/Index.vue'),
      meta: {
        title: '检测报告',
        sideBarKeepAlive: true
      }
    },
    {
      path: '/reportList',
      name: 'reportList',
      component: () => import('@/components/User/Report/List.vue'),
      meta: {
        title: '报告列表',
        sideBarKeepAlive: true
      }
    },
    {
      path: '/learnlist',
      name: 'learnList',
      component: () => import('@/components/User/Learn/List.vue'),
      meta: {
        title: '我的学术集',
        sideBarKeepAlive: true
      }
    },
    {
      path: '/userVipPay',
      name: 'userVipPay',
      component: () => import('@/components/User/VipPay/Index.vue'),
      meta: {
        title: '购买会员',
        metaInfo: {
          title: "腾讯首页",
          keywords: "资讯,新闻,财经,房产,视频,NBA,科技,腾讯网,腾讯,QQ,Tencent",
          description: "腾讯网从2003年创立至今，已经成为集新闻信息……"
        }
      }
    },
    {
      path: '/payResult',
      name: 'payResult',
      component: () => import('@/components/User/Payresult/Index.vue'),
      meta: {
        title: '购买会员',
        metaInfo: {
          title: "腾讯首页",
          keywords: "资讯,新闻,财经,房产,视频,NBA,科技,腾讯网,腾讯,QQ,Tencent",
          description: "腾讯网从2003年创立至今，已经成为集新闻信息……"
        }
      }
    },
    {
      path: '/member',
      name: 'member',
      component: () => import('@/components/User/Member/Index.vue'),
      meta: {
        title: 'CopyCheck会员在线激活'
      }
    },
    {
      path: '/active',
      name: 'active',
      component: () => import('@/components/User/Member/Active.vue'),
      meta: {
        title: 'CopyCheck会员在线激活'
      }
    },
    {
      path: '/Coupon',
      name: 'coupon',
      component: () => import('@/components/User/Coupon/Coupon.vue'),
      meta: {
        title: '领取优惠券'
      }
    },
    {
      path: '/coupon_activate',
      name: 'couponActivate',
      component: () => import('@/components/User/Coupon/CouponActivate.vue'),
      meta: {
        title: '优惠券激活'
      }
    },
    {
      path: '/welfare',
      name: 'welfare',
      component: () => import('@/components/User/Welfare/index.vue'),
      meta: {
        title: '领取查重券'
      }
    },
    {
      path: '/welfare_activate',
      name: 'welfareActivate',
      component: () => import('@/components/User/Welfare/active.vue'),
      meta: {
        title: '查重券激活'
      }
    },
    {
      path: '/pdfconvert',
      name: 'pdfConvert',
      component: () => import('@/components/User/PdfConvert/PdfConvert.vue'),
      meta: {
        title: 'PDF转换',
        sideBarKeepAlive: true
      }
    },
    {
      path: '/docfanyi',
      name: 'docfanyi',
      component: () => import('@/components/User/DocFanyi/DocFanyi.vue'),
      meta: {
        title: '文档翻译',
        sideBarKeepAlive: true
      }
    },
    {
      path: '/settype',
      name: 'settype',
      component: () => import('@/components/User/SetType/SetType.vue'),
      meta: {
        title: '人工排版',
        sideBarKeepAlive: true
      }
    },
    {
      path: '/paperhelp',
      name: 'paperhelp',
      component: () => import('@/components/User/PaperHelp/PaperHelp.vue'),
      meta: {
        title: '文献互助',
        sideBarKeepAlive: true
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js